import { observer } from 'mobx-react-lite'
import { Divider } from 'shared/ui'
import { useRcsContext } from 'pages/settings/pages/rcs/context/rcsContext'
import { RcsInfoFormSection } from './RcsInfoFormSection'

import styles from './styles.module.scss'

export const RcsInfoForm = observer(() => {
  const {} = useRcsContext()

  return (
    <section className={styles.container}>
      <RcsInfoFormSection section='general' />
      <Divider sx={{ marginY: '28px', borderColor: 'var(--black-10)' }} />
      <RcsInfoFormSection section='colorsAndImages' />
      <Divider sx={{ marginY: '28px', borderColor: 'var(--black-10)' }} />
      <RcsInfoFormSection section='contact' />
    </section>
  )
})
